import React, { useState } from 'react';
import { CenterBox, useQuery, sendEmailSignIn } from './Utils';
import validator from 'validator';


function EmailSignIn(props) {
  let [email, setEmail] = useState("");
  let [signinEmailLinkError, setSigninEmailLinkError] = useState(null);
  let [signinEmailLinkSuccess, setSigninEmailLinkSuccess] = useState(false);

  let query = useQuery();

  function signinEmailLink(e) {
    e.preventDefault();

    if (!validator.isEmail(email)) {
      setSigninEmailLinkError("Please enter a valid email address");
      return;
    }

    sendEmailSignIn(email).then(function () {
      // The link was successfully sent. Inform the user. Save the email
      // locally so you don't need to ask the user for it again if they open
      // the link on the same device.
      setSigninEmailLinkSuccess(true);
    })
    .catch(function (error) {
      console.log(error);
      setSigninEmailLinkError(error.message);
    });
  }


  return (
    <CenterBox>
      <div className="email-signin">
        <section>
          <>
          {signinEmailLinkSuccess &&
            <h2>Check your email for a link to sign in</h2>
          }

          {!signinEmailLinkSuccess &&
            <>
              <h2>Give Us Your Email and We'll Send You a Link to Sign In</h2>
              {/* <p>Note: You must have an invite to sign up. Contact hi@sudowrite.com if you believe you're on the list and are having trouble.</p> */}
              <form onSubmit={signinEmailLink}>
              <input type="text" placeholder="Your Email" name="email" value={email} onChange={e => {
                setEmail(e.target.value);
              }}></input>

              <button>Gimme the Link</button>

              {signinEmailLinkError &&
                <div className="error">{signinEmailLinkError}</div>
              }
              </form>
            </>

          }
          </>
        </section>
      </div>
    </CenterBox>
  );
}

export default EmailSignIn;
